import React, {Component} from 'react';
import { Button, ButtonGroup } from 'reactstrap'
import  './button.css';

/**
 * A ButtonGroup whose buttons act like a radio button.
 * Options should be passed as a list of [value, display] tuples.
 * Buttons are set up so you can use e.target.name and e.target.value in your
 * onChange handler like you would with regular form inputs.
 */

class RadioGroup extends Component {

  activeButton = (option, disabled, name, onChange) => {
    return (
      <Button
      key={option[0]}
      active
      children={option[1]}
      disabled={disabled}
      name={name}
      id={name}
      onClick={onChange}
      value={option[0]}
    />)
  }
  inactiveButton = (option, disabled, name, onChange) => {
    return (
    <Button
    key={option[0]}
    children={option[1]}
    disabled={disabled}
    name={name}
    id={name}
    onClick={onChange}
    value={option[0]}
  />)
  }
  render() {
    let {disabled, name, onChange, options, value } = this.props
    return <ButtonGroup className="flex-wrap">
      {options.map(option => { return (
        <>
        <Button style={ {fontSize: "14px", padding: "0.35rem"}}
        key={option[0]}
        active = {option[0] === value}
        children={option[1]}
        disabled={disabled}
        name={name}
        id={name}
        onClick={onChange}
        value={option[0]}
      />&nbsp;</>
      )})}
    </ButtonGroup>
  }
}

export default RadioGroup